import React from "react";
import { useSelector } from "react-redux";

export default function Footer() {
  const { primary_contact } = useSelector(
    (state) => state.rootReducer.scheduleSlice.sendData
  );
  return (
    <div className="schedule__footer tech__footer">
      <div className="tech__footer-left">
        <div className="tech__footer-company">
          {primary_contact?.firstname} {primary_contact?.lastname}
        </div>
        <div className="tech__footer-text">
          <img src="/assets/icons/phone.svg" alt="phone" />
          {primary_contact?.phone}
        </div>
        <div className="tech__footer-text">
          <img src="/assets/icons/email-icon.svg" alt="email" />
          {primary_contact?.email}
        </div>
      </div>
    </div>
  );
}
